const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
const isVgcfxDomain = /(^|\.)vgcfx\.com$/.test(hostname);
const isVeyonsDomain = /(^|\.)veyons\.com$/.test(hostname);

const config = {
  url: isVgcfxDomain
    ? 'https://api.vgcfx.com/'
    : isVeyonsDomain
      ? 'https://api.veyons.com/'
      : 'https://vgcfxapi.metaworld.solutions/'
};

export default config;
